<template>
  <path d="M18 12C18 8.6875 15.3125 6 12 6C8.6875 6 6 8.6875 6 12C6 15.3125 8.6875 18 12 18C15.3125 18 18 15.3125 18 12Z" />
</template>
